/* AXON theme behaviour. The `js` class on <html> is set by the inline script in layout/theme.liquid. */
(function () {
  'use strict';

  var root = document.documentElement;

  /* ---------- Theme toggle (light / dark) ---------- */
  var darkQuery = window.matchMedia('(prefers-color-scheme: dark)');

  function savedTheme() {
    try {
      return localStorage.getItem('axon-theme');
    } catch (e) {
      return null;
    }
  }

  function syncToggleButtons() {
    var dark = root.dataset.mode === 'dark';
    document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(dark));
      btn.setAttribute('aria-label', btn.dataset[dark ? 'labelLight' : 'labelDark']);
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-theme-toggle]');
    if (!btn) return;
    var next = root.dataset.mode === 'dark' ? 'light' : 'dark';
    root.dataset.mode = next;
    try {
      localStorage.setItem('axon-theme', next);
    } catch (e) {}
    syncToggleButtons();
  });

  // Follow the device only while the visitor has not chosen a theme themselves.
  darkQuery.addEventListener('change', function (event) {
    if (savedTheme() || root.dataset.defaultMode !== 'system') return;
    root.dataset.mode = event.matches ? 'dark' : 'light';
    syncToggleButtons();
  });

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Count-up numbers (stats bar) ---------- */
  function countUp(scope) {
    if (reducedMotion) return;
    scope.querySelectorAll('[data-count-up]').forEach(function (el) {
      var text = el.textContent.trim();
      if (!/^\d+$/.test(text) || el.dataset.counted) return;
      var target = parseInt(text, 10);
      el.dataset.counted = 'true';
      var start = null;
      var duration = Math.min(1600, 600 + target * 4);
      function frame(ts) {
        if (start === null) start = ts;
        var t = Math.min(1, (ts - start) / duration);
        el.textContent = Math.round(target * (1 - Math.pow(1 - t, 3)));
        if (t < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    });
  }

  function initCountUp() {
    var items = document.querySelectorAll('[data-count-up]');
    if (!items.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          countUp(entry.target.parentElement);
          io.unobserve(el);
        });
      },
      { threshold: 0.6 }
    );
    items.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- Blueprint grid glow + hero parallax ---------- */
  function initMotion() {
    var glow = document.querySelector('.grid-glow');
    var heroImg = document.querySelector('.hero__img');
    // Both effects are desktop-only; touch scrolling can't keep a synced layer still.
    if (reducedMotion || !finePointer) return;
    var pending = false;
    var mouseX = window.innerWidth / 2;
    var mouseY = window.innerHeight * 0.45;

    function paint() {
      pending = false;
      var y = window.scrollY;
      if (glow) {
        glow.style.setProperty('--scroll', (y % 80) + 'px');
        glow.style.setProperty('--gx', mouseX + 'px');
        glow.style.setProperty('--gy-light', mouseY + 'px');
      }
      if (heroImg && y < window.innerHeight * 1.2) {
        heroImg.style.transform = 'translate3d(0,' + y * 0.18 + 'px,0) scale(1.06)';
      }
    }

    function request() {
      if (!pending) {
        pending = true;
        requestAnimationFrame(paint);
      }
    }

    window.addEventListener('scroll', request, { passive: true });
    if (glow) {
      document.addEventListener(
        'pointermove',
        function (event) {
          mouseX = event.clientX;
          mouseY = event.clientY;
          glow.classList.add('is-on');
          request();
        },
        { passive: true }
      );
      document.documentElement.addEventListener('pointerleave', function () {
        glow.classList.remove('is-on');
      });
    }
    paint();
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('.reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        // Items that enter together (a row of cards) appear one after another, in page order.
        var visible = entries.filter(function (entry) {
          return entry.isIntersecting;
        });
        visible.forEach(function (entry, i) {
          var el = entry.target;
          el.style.transitionDelay = Math.min(i, 7) * 70 + 'ms';
          el.classList.add('is-visible');
          // Drop the delay once shown so hover effects stay instant.
          setTimeout(function () {
            el.style.transitionDelay = '';
            el.classList.add('is-settled');
          }, 1200);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    items.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  // Text is set via textContent: product titles and error messages come from the server.
  function showToast(message, link) {
    var toast = document.querySelector('.toast');
    if (!toast) return;
    var text = document.createElement('span');
    text.textContent = message;
    toast.replaceChildren(text);
    if (link) {
      var a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.label;
      toast.appendChild(a);
    }
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.hidden = true;
    }, 4500);
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-step]');
    if (!btn) return;
    var input = btn.closest('.qty').querySelector('input');
    var min = parseInt(input.min || '0', 10);
    var value = (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qtyStep, 10);
    input.value = Math.max(min, value);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product page: gallery ---------- */
  function showMedia(gallery, index) {
    var main = gallery.querySelectorAll('[data-media-main]');
    var thumbs = gallery.querySelectorAll('[data-media-thumb]');
    main.forEach(function (el, i) {
      el.hidden = i !== index;
    });
    thumbs.forEach(function (el, i) {
      el.setAttribute('aria-current', String(i === index));
    });
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-media-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    showMedia(gallery, parseInt(thumb.dataset.mediaThumb, 10));
  });

  /* ---------- Product page: variant picker ---------- */
  function initProductForm(section) {
    var dataEl = section.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = section.querySelector('form[action*="/cart/add"]');
    var idInput = form.querySelector('[data-variant-id]');
    idInput.disabled = false;
    var submit = form.querySelector('[type="submit"]');
    var priceEl = section.querySelector('[data-price]');
    var skuEl = section.querySelector('[data-sku]');
    var gallery = section.querySelector('[data-gallery]');
    var moneyFormat = dataEl.dataset.moneyFormat;
    var sticky = section.querySelector('[data-sticky-atc]');
    var stickyAdd = sticky && sticky.querySelector('[data-sticky-add]');
    var stickyPrice = sticky && sticky.querySelector('[data-sticky-price]');

    // Sticky Add to cart (mobile, via CSS): shown once the main button has scrolled above the viewport.
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }).observe(submit);
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    }

    function selectedOptions() {
      return Array.from(section.querySelectorAll('[data-option-index]')).map(function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var options = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === options[i];
        });
      });

      section.querySelectorAll('[data-option-index]').forEach(function (group, i) {
        var legendValue = group.querySelector('[data-option-value]');
        if (legendValue) legendValue.textContent = options[i] || '';
      });

      if (!variant) {
        submit.disabled = true;
        submit.querySelector('span').textContent = submit.dataset.unavailable;
        return;
      }

      idInput.value = variant.id;
      submit.disabled = !variant.available;
      submit.querySelector('span').textContent = variant.available ? submit.dataset.add : submit.dataset.soldOut;
      if (stickyAdd) {
        stickyAdd.disabled = !variant.available;
        stickyAdd.querySelector('span').textContent = submit.querySelector('span').textContent;
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      if (priceEl) {
        priceEl.innerHTML =
          formatMoney(variant.price) +
          (variant.compare_at_price > variant.price ? ' <s>' + formatMoney(variant.compare_at_price) + '</s>' : '');
      }
      if (skuEl) skuEl.textContent = variant.sku || '—';

      if (gallery && variant.featured_media) {
        var thumb = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) showMedia(gallery, parseInt(thumb.dataset.mediaThumb, 10));
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    section.addEventListener('change', function (event) {
      if (event.target.closest('[data-option-index]')) update();
    });
  }

  /* ---------- Cart drawer ---------- */
  var DRAWER_SECTION = 'cart-drawer';

  function drawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function openDrawer() {
    var d = drawer();
    if (d && !d.open) d.showModal();
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  // Swap in freshly rendered drawer markup (from the Section Rendering API) and sync the header count.
  function renderDrawer(html) {
    var d = drawer();
    if (!d || !html) return false;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer-content]');
    var current = d.querySelector('[data-cart-drawer-content]');
    if (!fresh || !current) return false;
    var scroll = current.querySelector('.cart-drawer__body');
    var top = scroll ? scroll.scrollTop : 0;
    current.replaceWith(fresh);
    var body = fresh.querySelector('.cart-drawer__body');
    if (body) body.scrollTop = top;
    updateCartCount(parseInt(fresh.dataset.itemCount, 10) || 0);
    return true;
  }

  function cartRequest(url, body) {
    return fetch(url, { method: 'POST', headers: { Accept: 'application/json' }, body: body }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Error');
        return data;
      });
    });
  }

  // Header cart icon opens the drawer instead of navigating (the link still works without JS).
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href="' + window.routes.cart + '"]');
    if (!link || !drawer() || event.metaKey || event.ctrlKey || link.closest('[data-cart-drawer]')) return;
    if (!link.closest('.site-header')) return;
    event.preventDefault();
    openDrawer();
  });

  // Click on the backdrop closes the drawer.
  document.addEventListener('click', function (event) {
    var d = drawer();
    if (d && event.target === d) d.close();
  });

  // Quantity +/− and Remove inside the drawer.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-line-change]');
    if (!btn) return;
    var body = new FormData();
    body.append('line', btn.dataset.lineChange);
    body.append('quantity', btn.dataset.quantity);
    body.append('sections', DRAWER_SECTION);
    body.append('sections_url', window.location.pathname);
    btn.disabled = true;
    cartRequest(window.routes.cartChange, body)
      .then(function (cart) {
        renderDrawer(cart.sections && cart.sections[DRAWER_SECTION]);
      })
      .catch(function (error) {
        showToast(error.message);
        btn.disabled = false;
      });
  });

  // Brief "Added ✓" on the button and a bump on the header cart icon.
  function confirmAdded(button) {
    document.querySelectorAll('[data-cart-icon]').forEach(function (icon) {
      icon.classList.remove('is-bumped');
      void icon.offsetWidth;
      icon.classList.add('is-bumped');
    });
    if (!button || button.dataset.addedTimer) return;
    var label = button.querySelector('span') || button;
    var original = label.innerHTML;
    label.textContent = button.classList.contains('card__quick-btn') ? '✓' : window.themeStrings.added;
    button.classList.add('is-added');
    button.dataset.addedTimer = 'true';
    setTimeout(function () {
      label.innerHTML = original;
      button.classList.remove('is-added');
      delete button.dataset.addedTimer;
    }, 1400);
  }

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[action*="/cart/add"]') || !window.fetch) return;
    event.preventDefault();

    var submit = form.querySelector('[type="submit"]') || document.querySelector('[form="' + form.id + '"][type="submit"]');
    if (submit) {
      submit.setAttribute('aria-busy', 'true');
      submit.disabled = true;
    }

    var d = drawer();
    var useDrawer = d && d.dataset.openOnAdd === 'true';
    var body = new FormData(form);
    if (d) {
      body.append('sections', DRAWER_SECTION);
      body.append('sections_url', window.location.pathname);
    }

    cartRequest(window.routes.cartAdd + '.js', body)
      .then(function (item) {
        confirmAdded(submit);
        var rendered = d && renderDrawer(item.sections && item.sections[DRAWER_SECTION]);
        if (useDrawer && rendered) {
          openDrawer();
          return;
        }
        return fetch(window.routes.cart + '.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            showToast(window.themeStrings.addedToCart.replace('%s', item.product_title), {
              href: window.routes.cart,
              label: window.themeStrings.viewCart,
            });
          });
      })
      .catch(function (error) {
        showToast(error.message);
      })
      .finally(function () {
        if (submit) {
          submit.removeAttribute('aria-busy');
          submit.disabled = false;
        }
      });
  });

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-sort-by]');
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Collection filters: apply on change ---------- */
  function submitFilters(form) {
    // Drop empty price inputs so they don't show up as blank URL params.
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    window.location.href = form.action + (params.toString() ? '?' + params.toString() : '');
  }

  document.addEventListener('change', function (event) {
    var form = event.target.closest('[data-filter-form]');
    if (!form || event.target.matches('[data-sort-by]')) return;
    if (event.target.matches('[data-filter-price]')) {
      clearTimeout(form._timer);
      form._timer = setTimeout(function () {
        submitFilters(form);
      }, 700);
      return;
    }
    submitFilters(form);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-filter-form]');
    if (!form) return;
    event.preventDefault();
    submitFilters(form);
  });

  // One open filter at a time.
  document.addEventListener(
    'toggle',
    function (event) {
      var opened = event.target;
      if (!opened.matches || !opened.matches('[data-filter]') || !opened.open) return;
      document.querySelectorAll('[data-filter][open]').forEach(function (el) {
        if (el !== opened) el.open = false;
      });
    },
    true
  );

  /* ---------- Header dropdown (touch + keyboard toggle; hover handled in CSS) ---------- */
  function closeDropdowns(except) {
    document.querySelectorAll('[data-nav-dropdown].is-open').forEach(function (el) {
      if (el === except) return;
      el.classList.remove('is-open');
      el.querySelector('.nav-dropdown__toggle').setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.nav-dropdown__toggle');
    if (toggle) {
      var dropdown = toggle.closest('[data-nav-dropdown]');
      var open = !dropdown.classList.contains('is-open');
      closeDropdowns(dropdown);
      dropdown.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      return;
    }
    if (!event.target.closest('[data-nav-dropdown]')) closeDropdowns();
    if (!event.target.closest('[data-filter]')) {
      document.querySelectorAll('[data-filter][open]').forEach(function (el) {
        el.open = false;
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeDropdowns();
    document.querySelectorAll('[data-filter][open]').forEach(function (el) {
      el.open = false;
      el.querySelector('summary').focus();
    });
  });

  /* ---------- Cart page: auto-submit on quantity change ---------- */
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty]');
    if (!input) return;
    clearTimeout(input._timer);
    input._timer = setTimeout(function () {
      input.form.submit();
    }, 500);
  });

  /* ---------- Product recommendations ---------- */
  function loadRecommendations(scope) {
    (scope || document).querySelectorAll('[data-recommendations]').forEach(function (placeholder) {
      var section = placeholder.closest('.shopify-section');
      fetch(placeholder.dataset.recommendations)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (!fresh || !section) return;
          section.innerHTML = fresh.innerHTML;
          initReveal(section);
        })
        .catch(function () {});
    });
  }

  /* ---------- "Ships by" date: today + N business days, in the visitor's own time zone ---------- */
  function initShipBy(scope) {
    (scope || document).querySelectorAll('[data-ship-by]').forEach(function (el) {
      var days = parseInt(el.dataset.days, 10) || 3;
      var date = new Date();
      while (days > 0) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) days -= 1;
      }
      var label = date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      var text = el.querySelector('[data-ship-by-text]');
      // The template is the theme's own translated string; the date goes in as text.
      text.innerHTML = el.dataset.template.replace('__DATE__', '<span data-ship-date></span>');
      var slot = text.querySelector('[data-ship-date]');
      if (slot) slot.textContent = label;
    });
  }

  /* ---------- Review carousel ---------- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-review-step]');
    if (!button) return;
    var track = button.closest('[data-review-carousel]').querySelector('[data-review-track]');
    var step = parseInt(button.dataset.reviewStep, 10);
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    var atStart = track.scrollLeft <= 4;
    if (step > 0 && atEnd) {
      track.scrollTo({ left: 0, behavior: 'smooth' });
    } else if (step < 0 && atStart) {
      track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: step * track.clientWidth, behavior: 'smooth' });
    }
  });

  /* ---------- Newsletter popup ---------- */
  var POPUP_KEY = 'axon-popup';
  var POPUP_SNOOZE_MS = 14 * 24 * 60 * 60 * 1000;

  function popupState() {
    try {
      return JSON.parse(localStorage.getItem(POPUP_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function savePopupState(status) {
    try {
      localStorage.setItem(POPUP_KEY, JSON.stringify({ status: status, at: Date.now() }));
    } catch (e) {}
  }

  function initPopup() {
    var popup = document.querySelector('[data-newsletter-popup]');
    if (!popup) return;
    if (popup.dataset.posted === 'true') {
      savePopupState('subscribed');
      popup.showModal();
      return;
    }
    if (popup.dataset.failed === 'true') {
      popup.showModal();
      return;
    }
    var state = popupState();
    if (state && (state.status === 'subscribed' || Date.now() - state.at < POPUP_SNOOZE_MS)) return;
    setTimeout(function () {
      // Don't interrupt someone who is in the middle of using the cart or another dialog.
      if (document.querySelector('dialog[open]')) return;
      popup.showModal();
    }, (parseInt(popup.dataset.delay, 10) || 15) * 1000);
    popup.addEventListener('close', function () {
      if (!popupState() || popupState().status !== 'subscribed') savePopupState('dismissed');
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-popup-close]')) {
      event.target.closest('dialog').close();
      return;
    }
    var popup = document.querySelector('[data-newsletter-popup]');
    if (popup && event.target === popup) popup.close();
    var copy = event.target.closest('[data-popup-copy]');
    if (copy && navigator.clipboard) {
      navigator.clipboard.writeText(copy.dataset.popupCopy).then(function () {
        copy.textContent = window.themeStrings.codeCopied;
      });
    }
  });

  /* ---------- Search modal with predictive results ---------- */
  function initSearch() {
    var modal = document.querySelector('[data-search-modal]');
    if (!modal || !window.routes.predictiveSearch) return;
    var input = modal.querySelector('[data-search-input]');
    var results = modal.querySelector('[data-search-results]');
    var timer = null;
    var controller = null;

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-search-open]')) {
        event.preventDefault();
        modal.showModal();
        input.focus();
        input.select();
      } else if (event.target.closest('[data-search-close]') || event.target === modal) {
        modal.close();
      }
    });

    function search() {
      var terms = input.value.trim();
      if (controller) controller.abort();
      if (terms.length < 2) {
        results.innerHTML = '';
        return;
      }
      controller = new AbortController();
      var url =
        window.routes.predictiveSearch +
        '?q=' + encodeURIComponent(terms) +
        '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search';
      fetch(url, { signal: controller.signal })
        .then(function (r) {
          return r.ok ? r.text() : '';
        })
        .then(function (html) {
          var found = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predictive-search-results]');
          results.innerHTML = found ? found.outerHTML : '';
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(search, 220);
    });
  }

  /* ---------- Recently viewed products (handles kept in this visitor's browser) ---------- */
  var RECENT_KEY = 'axon-recent';

  function readRecent() {
    try {
      var list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function initRecentlyViewed(scope) {
    var section = (scope || document).querySelector('[data-recently-viewed]');
    if (!section) return;
    var current = section.dataset.current;
    var limit = parseInt(section.dataset.limit, 10) || 4;
    var others = readRecent().filter(function (handle) {
      return handle !== current;
    });

    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify([current].concat(others).slice(0, 12)));
    } catch (e) {}

    var grid = section.querySelector('[data-recently-viewed-grid]');
    var wanted = others.slice(0, limit);
    if (!grid || !wanted.length) return;

    Promise.all(
      wanted.map(function (handle) {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        return fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=product-card-item')
          .then(function (r) {
            return r.ok ? r.text() : '';
          })
          .catch(function () {
            return '';
          });
      })
    ).then(function (pages) {
      var cards = pages
        .map(function (html) {
          return new DOMParser().parseFromString(html, 'text/html').querySelector('.card');
        })
        .filter(Boolean);
      if (!cards.length) return;
      cards.forEach(function (card) {
        grid.appendChild(card);
      });
      section.hidden = false;
      initReveal(section);
    });
  }

  /* ---------- Init ---------- */
  function init(scope) {
    syncToggleButtons();
    initReveal(scope);
    (scope || document).querySelectorAll('[data-product-section]').forEach(initProductForm);
    loadRecommendations(scope);
    initShipBy(scope);
    initRecentlyViewed(scope);
  }

  init();
  initSearch();
  initCountUp();
  initMotion();
  initPopup();

  // Re-init sections when edited in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
